import { queryKeys } from './queryKeys';

/**
 * Best-effort group header display from React Query cache (inbox row or prefetched shell).
 * Returns null when nothing useful is cached.
 */
export function readCachedGroupDisplay(queryClient, userId, groupId) {
  if (!queryClient || !groupId) return null;

  let name = null;
  let eventImageUrl = null;
  let eventId = null;

  const shell = queryClient.getQueryData(queryKeys.chats.group(groupId));
  if (shell?.name) name = shell.name;
  if (shell?.event_id) eventId = shell.event_id;

  if (userId) {
    const inbox = queryClient.getQueryData(queryKeys.chats.inbox(userId));
    if (Array.isArray(inbox)) {
      const row = inbox.find((r) => r.chat_kind === 'group' && r.group_id === groupId);
      if (row?.group_name) name = row.group_name;
      if (row?.event_image_url) eventImageUrl = row.event_image_url;
    }
  }

  if (!name && !eventImageUrl && !eventId) return null;
  return { name: name || null, eventImageUrl: eventImageUrl || null, eventId: eventId || null };
}

/** True when alt is a generic fallback, not a real group/event name. */
export function isGenericGroupLabel(label) {
  const trimmed = String(label || '').trim();
  return !trimmed || trimmed === 'Group' || trimmed === 'Event';
}
